import { render, staticRenderFns } from "./abnormal.vue?vue&type=template&id=2dff5bce&scoped=true"
import script from "./abnormal.vue?vue&type=script&lang=js"
export * from "./abnormal.vue?vue&type=script&lang=js"
import style0 from "./abnormal.vue?vue&type=style&index=0&id=2dff5bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dff5bce",
  null
  
)

export default component.exports